module.exports = require('./HeaderBarView');
